module.exports = require('./HeaderBarView');
